import type { AccountSecret as AccountSecretModel } from '@/adapters/catalogv1.g';

export function extractAccountSecret(model: AccountSecretModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    accountRef: model.account_ref ?? '',
    secretRef: model.secret_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAccountSecret = ReturnType<typeof extractAccountSecret>;
